import { Shirt, Store, PackageSearch, LineChart } from "lucide-react";
import { SectionHead, Reveal } from "./shared";

const AUDIENCES = [
  { icon: Shirt, title: "Brechós", desc: "Peças únicas, consignação e lotes com custos distintos — cada item com sua margem visível." },
  { icon: Store, title: "Varejistas", desc: "Lojas que compram coleções por lote e precisam garantir giro e lucro sem queima desordenada." },
  { icon: PackageSearch, title: "Operações com compra por lote", desc: "Negócios que adquirem mercadoria em volume e precisam saber o que cada compra realmente gera." },
  { icon: LineChart, title: "Gestores com visão gerencial", desc: "Quem quer administrar por indicadores — e não apenas pelo saldo da conta bancária." },
];

export const Audience = () => (
  <section id="para-quem" data-testid="audience-section" className="relative py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <SectionHead
        eyebrow="Para quem é"
        testId="audience-head"
        title={<>Quem pode usar <span className="text-gradient-blue">a TRIA</span></>}
        sub="Feita para quem vive de compra, margem e giro — e quer clareza sobre o resultado."
      />

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {AUDIENCES.map((a, i) => (
          <Reveal key={a.title} delay={i * 0.08}>
            <div
              data-testid={`audience-card-${i + 1}`}
              className="group flex h-full flex-col rounded-2xl border border-white/[0.07] bg-white/[0.02] p-7 transition-all duration-300 hover:-translate-y-1.5 hover:border-tria-blue/40 hover:shadow-[0_20px_50px_-20px_rgba(26,100,255,0.45)]"
            >
              <span className="mb-6 inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br from-tria-vivid/30 to-tria-sky/10 text-tria-sky transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3">
                <a.icon className="h-5.5 w-5.5" />
              </span>
              <h3 className="font-display text-lg font-semibold text-white">{a.title}</h3>
              <p className="mt-2.5 text-[13.5px] leading-relaxed text-tria-mist">{a.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
